import { get, post, put } from '@/common/admin_ajax'

const getBuildingBlocks = (buiding_id, image_id) => get(`buildings/${buiding_id}/building_blocks.json?planar_graph_image_id=${image_id}`)
const putBuildingBlockCoordinate = (buiding_id, id, data) => put(`buildings/${buiding_id}/building_blocks/${id}/coordinate.json`, data)
const createBlockPlanarGraph = (building_id, image_id) => post(`buildings/${building_id}/building_images/${image_id}/generate_imgs`, { generator: 'block_planar_graph_image' })
const addCenterCoordinate = (building_id, image_id, center_coordinate) => put(`buildings/${building_id}/building_images/${image_id}/coordinate`, { center_coordinate })
const updateBatchCoordinate = (building_id, data) => put(`buildings/${building_id}/building_blocks/coordinate_batch_modify`, data)

export default {
    getBuildingBlocks,
    putBuildingBlockCoordinate,
    createBlockPlanarGraph,
    addCenterCoordinate,
    updateBatchCoordinate
}